import type { FC } from 'react';

import { useIsFeatureVisibleToOrg } from '@/utils/featureFlags';

import { WidgetLoading } from '../../widgets/widget-loading';
import { WidgetPieChartCloudscape } from './WidgetPieChart.cloudscape';
import { WidgetPieChartHighcharts } from './WidgetPieChart.highcharts';

export type Props = {
  loading: boolean;
  data: { x: unknown; y: unknown; color?: string; label?: string }[];
  donut: boolean;
  innerMetricValue?: string;
  onSegmentClick?: (data: SegmentData) => void;
  showAsPercentage?: boolean;
};
export type SegmentData = { value: unknown };

export const WidgetPieChart: FC<Props> = (props) => {
  const highchartsEnabled = useIsFeatureVisibleToOrg('highcharts');

  if (props.loading) {
    return <WidgetLoading />;
  }

  if (highchartsEnabled) {
    return <WidgetPieChartHighcharts {...props} />;
  }

  return <WidgetPieChartCloudscape {...props} />;
};
